import { ContainerStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsEnum, IsNotEmpty } from "class-validator";

export class DispatchedToPlant{
    @ApiProperty()
    containerNumber:string;
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty()
    containerSize:string;
    @ApiProperty({enum:Object.values(ContainerStatusEnum)})
    @IsNotEmpty()
    @IsEnum(ContainerStatusEnum)
    containerStatus:ContainerStatusEnum;
    @ApiProperty()
    createdUser:string;
    @ApiProperty()
    updatedUser?:string;
    @ApiProperty()
    containerId?:number;

    /**
     * 
     * @param containerNumber 
     * 
     * @param saleOrderId 
     * @param containerSize 
     * @param containerStatus 
     * @param createdUser 
     * @param containerId 
     * @param updatedUser 
     */
    constructor(containerNumber:string, saleOrderId:number, containerSize:string, containerStatus:ContainerStatusEnum, createdUser:string, containerId?:number, updatedUser?:string){
        this.containerNumber = containerNumber;
        this.saleOrderId = saleOrderId;
        this.containerSize = containerSize;
        this.containerStatus = containerStatus;
        this.containerId = containerId;
        this.createdUser = createdUser;
        this.updatedUser = updatedUser;
    }
}